<div class="toast-container">
  @for (toast of toasts; track toast._id; let i = $index) {
    @switch (toast.type) {
      @case ('noHeader') {
        <ng-container *ngTemplateOutlet="noHeader; context: { toast: toast, i: i }"></ng-container>
      }
      @case ('withHeader') {
        <ng-container *ngTemplateOutlet="withHeader; context: { toast: toast, i: i }"></ng-container>
      }
      @default {
        <ng-container *ngTemplateOutlet="noHeader; context: { toast: toast, i: i }"></ng-container>
      }
    }
  }
</div>

<ng-template #noHeader let-toast="toast" let-i="i">
  <div @toastAnimation class="toast toast__solo" [ngClass]="'bg-' + toast.level">
    <div class="flex full-width">
      <div class="toast-body flex-1">
        <a [routerLink]="[toast.link ? toast.link : '']">{{ toast.text }}</a>
      </div>
      <button type="button" class="btn-close me-4 m-auto cursor" (click)="removeToast(i)"></button>
    </div>
  </div>
</ng-template>

<ng-template #withHeader let-toast="toast" let-i="i">
  <div @toastAnimation class="toast">
    <div class="toast-header" [ngClass]="'bg-' + (toast.level ? toast.level : 'info')">
      <strong class="mr-auto">{{ toast.header }}</strong>
      <button type="button" class="btn-close cursor" (click)="removeToast(i)"></button>
    </div>
    <div class="toast-body">
      <a [routerLink]="[toast.link ? toast.link : '']">{{ toast.text }}</a>
    </div>
  </div>
</ng-template>
